import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, Download } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useUi } from "@/lib/uiConfig";
import { isIOS, isStandalone, canInstall, promptInstall } from "@/lib/push";
import { InstallSteps } from "@/components/InstallSteps";

const KEY = "itz_install_popup_day";
const today = () => new Date().toLocaleDateString("de-DE", { timeZone: "Europe/Berlin" });
const busy = () => document.querySelector('[role="dialog"],[data-testid="lucky-wheel-modal"],[data-testid="install-prompt"],[data-testid="level-up-modal"]');

export function InstallPopupView({ image, onClose, preview }) {
  const [steps, setSteps] = useState(false);
  const install = async () => {
    if (!preview && canInstall() && !isIOS() && await promptInstall()) return onClose();
    setSteps(true);
  };
  return createPortal(
    <div className="fixed inset-0 z-[87] flex items-end sm:items-center justify-center p-4 pb-8 bg-rose-950/55 backdrop-blur-sm wheel-fade" data-testid="install-popup">
      <div className="redeem-rise relative w-full max-w-sm max-h-[92vh] overflow-y-auto rounded-[2rem] bg-white text-center wheel-frame">
        <button type="button" onClick={onClose} aria-label="Schließen" data-testid="install-popup-close" className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 shadow flex items-center justify-center"><X className="w-4 h-4" /></button>
        <img src={image} alt="itzPlay App" className="w-full aspect-square object-cover rounded-t-[2rem]" data-testid="install-popup-image" />
        <div className="p-6 pt-4">
          <h3 className="font-display text-2xl font-extrabold">Hol dir die itzPlay App 💖</h3>
          <p className="mt-1 text-sm text-slate-500">Kostenlos auf deinen Home-Bildschirm – schneller öffnen, Push-Nachrichten und nichts mehr verpassen.</p>
          {steps ? <div className="mt-4 text-left" data-testid="install-popup-steps"><InstallSteps compact /></div> : (
            <button type="button" onClick={install} data-testid="install-popup-install" className="mt-5 w-full py-3.5 rounded-full pink-gradient text-white text-lg font-extrabold shadow-lg shadow-rose-300 active:scale-95 transition-transform wheel-cta inline-flex items-center justify-center gap-2"><Download className="w-5 h-5" /> App installieren</button>
          )}
          <button type="button" onClick={onClose} data-testid="install-popup-later" className="mt-3 text-sm font-semibold text-slate-400">Vielleicht später</button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export function InstallFeedPopup() {
  const { user } = useAuth();
  const p = useUi()?.install_popup;
  const [open, setOpen] = useState(false);
  const on = !!p?.enabled && !user?.app_installed_at && !isStandalone();
  const stamp = `${today()}|${p?.version || ""}`;
  useEffect(() => {
    if (!on) return undefined;
    if (localStorage.getItem(KEY) === stamp) return undefined;
    let n = 0;
    const iv = setInterval(() => { if (++n > 40 || !busy()) { clearInterval(iv); if (n <= 40) setOpen(true); } }, 2500);
    return () => clearInterval(iv);
  }, [on, stamp]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!open || !on) return null;
  return <InstallPopupView image={p.image} onClose={() => { localStorage.setItem(KEY, stamp); setOpen(false); }} />;
}
